<template>
	<div class="nav">
		<img src="../../assets/shumeilogo-bar.png" alt="logo" @click="goHome" />
		<div class="tab">
			<router-link to="/" @mouseover.native="hideTab" exact>首页</router-link>
			<router-link to="/introduce" @mouseover.native="hideTab">产品介绍</router-link>
			<router-link to="/eduPlatform" @mouseover.native="hideTab">教育局平台</router-link>
			<!-- <router-link to="/classWallet" @mouseover.native="hideTab">班级钱包</router-link> -->
			<router-link to="/cooperation" @mouseover.native="hideTab">商务合作</router-link>
			<router-link to="/school" @mouseover.native="hideTab">案例中心</router-link>
			
			<div class="about">
				<router-link to="/about" @mouseover.native="showTab">关于我们</router-link>
				<!-- <div v-if="showAbout" class="tab_under" @mouseleave="hideTab">
          <router-link :to="{ name: 'About', query: { tab: 0}}" >公司简介</router-link>
          <router-link :to="{ name: 'About', query: { tab: 1}}" >联系我们</router-link>
        </div>-->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				chooseIndex: 0,
				showAbout: false
			};
		},
		computed: {},
		watch: {},
		methods: {
			goHome() {
				this.$router.push({
					path: "/"
				});
			},
			showTab() {
				this.showAbout = true;
			},
			hideTab() {
				this.showAbout = false;
			}
		},
		created() {},
		mounted() {},
		beforeCreate() {},
		beforeMount() {},
		beforeUpdate() {},
		updated() {},
		beforeDestroy() {},
		destroyed() {},
		activated() {}
	};
</script>
<style scoped>
	.nav {
		width: 100%;
		height: 0.4167rem;
		display: -webkit-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		-webkit-box-orient: horizontal;
		-ms-flex-direction: row;
		-webkit-flex-direction: row;
		flex-direction: row;
		-webkit-box-align: center;
		-ms-flex-align: center;
		-webkit-align-items: center;
		align-items: center;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		-webkit-justify-content: space-between;
		justify-content: space-between;
		padding-right: 1.875rem;
		box-sizing: border-box;
	}

	.nav img {
		width: 0.7396rem;
		height: 0.2083rem;
		margin-left: 1.875rem;
	}

	.tab {
		/* width: 900px; */
		height: 0.4167rem;
		display: -webkit-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		-webkit-align-items: center;
		align-items: center;
		/* justify-content: space-between; */
		/* margin-left: 0.8333rem; */
	}

	/* .tab a {
  text-decoration: none;
  font-size: 0.0833rem;
  font-weight: 400;
  color: rgba(9, 22, 48, 1);
  line-height: 0.0833rem;
} */
	/* .tab span {
  font-size: 0.0833rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(9, 22, 48, 1);
  line-height: 0.0833rem;
} */
	a {
		height: 0.4167rem;
		font-size: 0.0833rem;
		font-weight: 400;
		color: rgba(9, 22, 48, 1);
		line-height: 0.4167rem;
		text-decoration: none;
		margin: 0 0.2083rem;
		/* border-top: 0.0104rem solid rgba(47, 110, 240, 1); */
	}

	body a:hover {
		color: rgba(63, 110, 240, 1);
	}

	.router-link-active {
		text-decoration: none;
		color: rgba(63, 110, 240, 1);
		border-top: 0.0104rem solid rgba(47, 110, 240, 1);
		box-sizing: border-box;
	}

	.about {
		position: relative;
		display: -webkit-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		flex-direction: column;
	}

	.tab_under {
		position: absolute;
		width: 0.75rem;
		height: 0.7917rem;
		background: rgba(255, 255, 255, 1);
		top: 0.4167rem;
		left: 0;
		display: -webkit-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		flex-direction: column;
		-webkit-box-align: center;
		-ms-flex-align: center;
		-webkit-align-items: center;
		align-items: center;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
	}

	.tab_under a.router-link-active {
		text-decoration: none;
		/* color: rgba(63, 110, 240, 1); */
		border-top: 0;
	}

	.tab_under a:first-child {
		margin-bottom: 0.2083rem;
	}

	.tab_under a {
		font-size: 0.0833rem;
		font-weight: 400;
		color: rgba(9, 22, 48, 1);
		line-height: 0.0833rem;
		height: auto;
		margin: 0;
	}
</style>
